var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.plugin)?_c('canvas',{ref:"canvas",attrs:{"at-id":'at-diagram-canvas-' + _vm.plugin.title.toLowerCase().replace(/\s/g,'-'),"width":_vm.sizeCanvas.width,"height":_vm.sizeCanvas.height}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }